<script setup lang="ts">
import AppNavbar from "./components/AppNavbar/AppNavbar.vue";
import AppNavbarLogin from "./components/AppNavbar/AppNavbarLogin.vue";
import AppVersion from "./components/AppVersion/AppVersion.vue";
import { onMounted } from "vue";
import { useUserStore } from "@/App/user/user.store";
import WhatsNewPopup from "./components/WhatsNewPopup.vue";
import FeedbackModal from "@/App/components/feedback/FeedbackModal.vue";
import IdleDetector from "@/App/components/IdleDetector.vue";
import { useTimedSession } from "@/App/composables/useTimedSession/useTimedSession";

const userStore = useUserStore();

const { onTimeout, timedSessionOn, timeoutTime } = useTimedSession();

onMounted(() => {
  userStore.onAppStarted();
});
</script>

<template>
  <template v-if="userStore.user">
    <IdleDetector v-if="timedSessionOn && timeoutTime" :seconds-before-timeout="timeoutTime" @idle="onTimeout" />

    <div class="app__head">
      <AppNavbar />
    </div>
  </template>
  <template v-else>
    <div class="app__head">
      <AppNavbarLogin />
    </div>
  </template>

  <div class="app__body">
    <div class="router-view">
      <RouterView />
    </div>
  </div>

  <AppVersion />
  <WhatsNewPopup v-if="userStore.user" />
  <FeedbackModal v-if="userStore.user" />
</template>

<style>
:root {
  --section-height: calc(100vh - 8rem);
  --section-height-with-hospitals-statuses-bar: calc(100vh - 10rem);
}

.main-content {
  margin-inline: max(2rem, 50% - 43rem);
}
</style>

<style scoped>
.app__head {
  z-index: 1;
}

.app__body {
  flex: 1 1 auto;
  position: relative;
}

.app__body > .router-view {
  height: 100%;
}
</style>
